<form [formGroup]="hierarchyForm" fxLayout="column" autocomplete="off">
  <div class="container">
    <h3>{{ 'menu.OrganizationHierarchy' | translate }}</h3>
  </div>

  <div class="myGridList" style="display: flex; width: 100%; height: 600px;">
    <!-- Left Column: Tree View -->
    <div class="tree-container" style="flex: 1; padding-right: 10px; overflow: auto;">
      <!-- Checkbox to Expand/Collapse All -->
      <div style="margin-bottom: 10px;">
        <input type="checkbox"
               id="toggleTree"
               (change)="toggleTreeNodes($event)" />
        <label for="toggleTree">{{ 'common.ExpandCollapseAll' | translate }}</label>
      </div>

      <p-tree #tree
              [value]="treeData"
              selectionMode="single"
              [(selection)]="selectedNode"
              (onNodeSelect)="selectNode($event)"
              [style]="{ 'max-height': '100%', 'overflow': 'auto'}">
        <ng-template let-node pTemplate="default">
          {{ node.label }}
        </ng-template>
      </p-tree>
    </div>


    <!-- Right Column: Form Controls -->
    <div class="form-controls-container" style="flex: 2; padding-left: 10px;">
      <!-- Company Form -->
      <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="1em" style="margin-bottom: 0.5em; font-size: 0.9rem;">
        <input type="hidden" formControlName="companyId" />
        <label style="flex: 1; font-size: 0.9rem;">{{ 'common.Company' | translate }}</label>
        <input type="number"
               formControlName="company"
               min="1"
               max="9999"
               class="small-input" />
        <input type="text"
               formControlName="companyName"
               maxlength="40"
               class="small-input" />
        <div class="button-group" style="flex: 1; display: flex; gap: 0.5em;">
          <button mat-icon-button (click)="createCompany()" [disabled]="!writeRight" matTooltip="{{ 'common.Add' | translate }}">
            <mat-icon color="primary">add</mat-icon>
          </button>
          <button mat-icon-button (click)="editCompany()" [disabled]="!writeRight" matTooltip="{{ 'common.Edit' | translate }}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteCompany()" [disabled]="!writeRight" matTooltip="{{ 'common.Delete' | translate }}">
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </div>
      </div>

      <!-- Factory Form -->
      <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="1em" style="margin-bottom: 0.5em; font-size: 0.9rem;">
        <input type="hidden" formControlName="factoryId" />
        <label style="flex: 1; font-size: 0.9rem;">{{ 'common.Factory' | translate }}</label>
        <input type="number"
               formControlName="factory"
               min="1"
               max="9999"
               class="small-input" />
        <input type="text"
               formControlName="factoryName"
               maxlength="40"
               class="small-input" />
        <div class="button-group" style="flex: 1; display: flex; gap: 0.5em;">
          <button mat-icon-button (click)="createFactory()" [disabled]="!writeRight" matTooltip="{{ 'common.Add' | translate }}">
            <mat-icon color="primary">add</mat-icon>
          </button>
          <button mat-icon-button (click)="editFactory()" [disabled]="!writeRight" matTooltip="{{ 'common.Edit' | translate }}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteFactory()" [disabled]="!writeRight" matTooltip="{{ 'common.Delete' | translate }}">
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </div>
      </div>

      <!-- Department Form -->
      <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="1em" style="margin-bottom: 0.5em; font-size: 0.9rem;">
        <input type="hidden" formControlName="departmentId" />
        <label style="flex: 1; font-size: 0.9rem;">{{ 'common.Department' | translate }}</label>
        <input type="number"
               formControlName="department"
               min="1"
               max="9999"
               class="small-input" />
        <input type="text"
               formControlName="departmentName"
               maxlength="40"
               class="small-input" />
        <div class="button-group" style="flex: 1; display: flex; gap: 0.5em;">
          <button mat-icon-button (click)="createDepartment()" [disabled]="!writeRight" matTooltip="{{ 'common.Add' | translate }}">
            <mat-icon color="primary">add</mat-icon>
          </button>
          <button mat-icon-button (click)="editDepartment()" [disabled]="!writeRight" matTooltip="{{ 'common.Edit' | translate }}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteDepartment()" [disabled]="!writeRight" matTooltip="{{ 'common.Delete' | translate }}">
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </div>
      </div>

      <!-- Section Form -->
      <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="1em" style="margin-bottom: 0.5em; font-size: 0.9rem;">
        <input type="hidden" formControlName="sectionId" />
        <label style="flex: 1; font-size: 0.9rem;">{{ 'common.Section' | translate }}</label>
        <input type="number"
               formControlName="section"
               min="1"
               max="9999"
               class="small-input" />
        <input type="text"
               formControlName="sectionName"
               maxlength="40"
               class="small-input" />
        <div class="button-group" style="flex: 1; display: flex; gap: 0.5em;">
          <button mat-icon-button (click)="createSection()" [disabled]="!writeRight" matTooltip="{{ 'common.Add' | translate }}">
            <mat-icon color="primary">add</mat-icon>
          </button>
          <button mat-icon-button (click)="editSection()" [disabled]="!writeRight" matTooltip="{{ 'common.Edit' | translate }}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteSection()" [disabled]="!writeRight" matTooltip="{{ 'common.Delete' | translate }}">
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
